import CardDeeplinkComponent from '@views/decks/cards/deeplink';
import DeckDeeplinkComponent from '@views/decks/deeplink';
import FlashcardDeeplinkComponent from '@views/flashcards/deeplink';
import NavigationGroupDeeplinkComponent from '@views/navigationGroups/deeplink';
import PurchaseOrderDeeplinkComponent from '@views/singletons/purchase-order-deeplink';
import TopicDeeplinkComponent from '@views/topics/deeplink';

/***************************************************************
   __
 /    \      Before you get all excited about dropping
| STOP |     a new deeplink route in here, be sure that
 \ __ /      you have the following:
   ||         - Backend support for the data model in the
   ||           deeplinks controller
   ||         - Have mapped the deeplink query string from
   ||           the backend to the appropriate route name
   ||           and params in the router index and map files.
***************************************************************/

export default [
  {
    path: '/deeplinks',
    name: 'deeplink',
    meta: {
      public: true,
      secondaryRoute: true,
    },
  },
  {
    path: '/deeplinks/flashcard/:flashcardId?',
    name: 'deeplinks#flashcard',
    component: FlashcardDeeplinkComponent,
    meta: {
      resourceOptional: true,
      masteryFooter: true,
      secondaryRoute: true,
    },

  },
  {
    path: '/deeplinks/navigationGroup/:navigationGroupId?',
    name: 'deeplinks#navigationGroup',
    component: NavigationGroupDeeplinkComponent,
    meta: {
      resourceOptional: true,
      secondaryRoute: true,
    },
  },
  {
    path: '/deeplinks/topic/:topicId?/:subtopicId?',
    name: 'deeplinks#topic',
    component: TopicDeeplinkComponent,
    meta: {
      resourceOptional: true,
      secondaryRoute: true,
    },
  },
  {
    path: '/deeplinks/deck/:deckId',
    name: 'deeplinks#deck',
    component: DeckDeeplinkComponent,
    meta: {
      header: true,
      resourceOptional: true,
      secondaryRoute: true,
    },
  },
  {
    path: '/deeplinks/card/:cardId',
    name: 'deeplinks#card',
    component: CardDeeplinkComponent,
    meta: {
      resourceOptional: true,
      secondaryRoute: true,
    },
  },
  {
    path: '/deeplinks/purchaseOrder/:purchaseOrderId?',
    name: 'deeplinks#purchaseOrder',
    component: PurchaseOrderDeeplinkComponent,
    meta: {
      resourceOptional: true,
      secondaryRoute: true,
    },
  },
];
